const TEXT_NODE = 3
const ESPECIFICACIONES_SVG = `<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.63 82.06" style="display: block;width: 1em; height: 1em;">
  <path d="m.02,40.95c0-12.21,0-24.42,0-36.63,0-.77-.03-1.54-.02-2.31C.03.72.6.12,1.88.01c.18-.02.36-.01.54-.01C25.68,0,48.93,0,72.19,0c.1,0,.2,0,.3,0,1.52.03,2.14.66,2.14,2.18,0,15.43,0,30.85,0,46.28,0,4.22-.01,8.44.01,12.65,0,.83-.26,1.47-.85,2.05-3.07,3.03-6.13,6.08-9.18,9.13-2.64,2.63-5.27,5.26-7.91,7.89-.36.36-.72.72-1.06,1.1-.48.53-1.07.78-1.79.77-3.45-.02-6.89-.02-10.34-.02-13.13,0-26.26,0-39.39,0-.79,0-1.58.04-2.36,0-1.01-.06-1.6-.64-1.68-1.65-.05-.6-.05-1.21-.05-1.82,0-12.54,0-25.08,0-37.61h0Zm52.21,37.45c.01-.2.02-.32.02-.43,0-2.4,0-4.79.01-7.19,0-3.12,0-6.24,0-9.35,0-.97.55-1.55,1.51-1.69.27-.04.56-.06.83-.06,5.35,0,10.7.02,16.05.03.08,0,.15-.02.21-.03V3.67c-.38,0-.7,0-1.03,0-21.88,0-43.75.01-65.63,0-.42,0-.52.12-.52.53.01,24.53.01,49.07,0,73.6,0,.46.12.57.57.57,15.48,0,30.95.01,46.43.02.49,0,.98,0,1.52,0Zm16.01-14.93c-.15-.03-.24-.06-.33-.06-3.87,0-7.74,0-11.61,0-.3,0-.36.14-.36.39.01.7.02,1.41.02,2.12,0,3.1-.02,6.2-.03,9.3,0,.17.04.33.06.5,4.1-4.1,8.15-8.14,12.24-12.24Z"/>
  <path d="m37.32,46.65c6.05,0,12.11,0,18.16,0,.26,0,.53-.01.79.02.87.12,1.48.83,1.52,1.73.04.96-.49,1.7-1.37,1.9-.27.06-.55.08-.83.08-12.21,0-24.42,0-36.62,0-1.15,0-1.8-.35-2.05-1.17-.4-1.35.25-2.54,1.69-2.56,1.28-.01,2.56,0,3.84,0,4.96,0,9.91,0,14.87,0h0Z"/>
  <path d="m37.36,39.11c-5.5,0-10.99,0-16.49,0-.85,0-1.71.03-2.56-.03-.86-.06-1.46-.74-1.49-1.55-.04-1.07.45-1.8,1.36-1.99.32-.06.65-.09.98-.09,12.08,0,24.16,0,36.23,0,.29,0,.59.01.88.06.96.17,1.55.9,1.52,1.88-.03.94-.67,1.65-1.63,1.71-.9.05-1.8,0-2.7,0-5.37,0-10.73,0-16.1,0Z"/>
  <path d="m41.02,28.02c-4.79,0-9.58,0-14.37,0-.23,0-.46-.01-.69-.04-1.16-.13-1.7-.77-1.68-1.95.02-1.07.64-1.69,1.77-1.75.54-.03,1.08-.01,1.62-.01,9.22,0,18.43,0,27.65,0,.28,0,.56.01.84.04.94.09,1.59.78,1.63,1.73.04.98-.55,1.76-1.48,1.91-.32.05-.65.07-.98.07-4.77,0-9.55,0-14.32,0h0Z"/>
</svg>`
const FOOT_SIZE_SVG = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 100 100" style="enable-background:new 0 0 100 100; display: block;width: 1em; height: 1em;" xml:space="preserve">
<style type="text/css">
.st0{fill:#1D1D1B;}
</style>
<path class="st0" d="M60.35,38.74c0.51-1.04,0.99-2.03,1.48-3.02c4.22-8.46,9.04-16.54,15.54-23.46c2.15-2.29,4.63-4.26,6.96-6.37
c0.12-0.11,0.26-0.2,0.39-0.3c0.57-0.44,1.16-0.52,1.65,0.08c0.51,0.65,0.15,1.14-0.39,1.58c-1.62,1.34-3.29,2.62-4.81,4.06
c-6.03,5.74-10.65,12.55-14.6,19.81c-2.03,3.74-3.78,7.63-5.66,11.45c-3.36,6.79-3.09,13.6-0.23,20.46
c3.75,8.99,10.37,14.88,19.44,18.18c1.28,0.47,2.6,1,3.67,1.81c2.52,1.93,3.38,5.24,2.4,8.25c-0.97,2.95-3.57,5.16-6.74,5.2
c-7.38,0.08-14.77,0.11-22.15-0.13c-4.87-0.16-9.13-2.27-12.79-5.46c-7.43-6.47-14.83-12.96-22.21-19.48
c-2.09-1.84-4.17-3.71-6.05-5.76c-1.76-1.92-2.82-4.28-2.89-6.95c-0.08-3.25,1.37-5.87,3.49-8.2c2.89-3.18,5.96-6.22,8.61-9.58
c4.81-6.12,8.3-13.05,11.5-20.1c2.36-5.2,4.34-10.55,5.94-16.03c0.06-0.22,0.07-0.53,0.22-0.64c0.38-0.28,0.84-0.69,1.24-0.66
c0.61,0.04,0.93,0.59,0.76,1.25c-0.24,0.95-0.44,1.93-0.78,2.84c-1.95,5.15-3.92,10.28-5.92,15.41c-0.21,0.55-0.33,0.88,0.27,1.28
c7.01,4.69,13.99,9.41,20.98,14.12C59.89,38.49,60.09,38.59,60.35,38.74z M57.87,61.42c-2.62-7.2-1.88-14.04,1.64-20.64
c-7.51-5.05-14.91-10.02-22.29-14.97c-1.6,2.91-3.07,5.76-4.7,8.52c-1.63,2.76-3.42,5.43-5.18,8.22c1.93,1.53,3.94,3.11,5.94,4.69
c5,3.94,9.98,7.89,14.99,11.82C51.03,61.23,54.16,62.09,57.87,61.42z M28.14,73.82c5.69,5,11.33,9.95,16.99,14.91
C51.1,82.93,57,77.2,62.7,71.67c-1.37-2.66-2.66-5.12-3.9-7.6c-0.24-0.47-0.44-0.57-0.96-0.49c-3.73,0.58-7.17-0.19-10.27-2.37
c-0.88-0.62-1.72-1.31-2.65-2.02C39.35,64.05,33.77,68.91,28.14,73.82z M46.75,90.11c3.29,2.53,6.87,4.12,10.86,4.22
c7.21,0.18,14.43,0.12,21.64,0.07c2.54-0.02,4.61-1.95,5.06-4.42c0.51-2.77-0.97-5.3-3.74-6.23c-3.44-1.15-6.77-2.55-9.68-4.7
c-2.36-1.74-4.53-3.74-6.87-5.7C58.4,78.8,52.62,84.41,46.75,90.11z M43.24,57.82c-5.83-4.6-11.59-9.14-17.24-13.61
c-2.75,2.87-5.48,5.57-8.03,8.43c-3.24,3.63-3.48,7.73-0.3,11.4c2.62,3.03,5.76,5.61,8.7,8.42C32.07,67.51,37.62,62.7,43.24,57.82z"
/>
</svg>
`


class TabsNavigator extends HTMLElement {
  constructor() {
    super()
    this.onlyTabs = this.dataset.onlyTabs == "true"
    this.tabTitle = this.dataset.tabTitle
    this.defaultActive = this.dataset.defaultActive == "true"
    const BP = 750
    this.desktop = this.dataset.desktop || "acordeon"
    this.mobile = this.dataset.mobile || "acordeon"
    this.container = document.createElement("div")

    this.container.classList.add("tabs-navigator")
    this.container.innerHTML = `
    <nav class="tabs-navigator--nav">
      <ul class="tabs-navigator__menu"></ul>
    </nav>
    <div class="tabs-navigator--sections">
    </div>`
    this.tabsNavigator = this.container.querySelector(".tabs-navigator__menu")
    this.sectionsContainer = this.container.querySelector(".tabs-navigator--sections")

    const displayTab = (e) => {
      e.preventDefault()
      const link = e.target
      const section = this.querySelector(`${link.getAttribute("href")}`)
      if (!section) return false

      if (this.sectionActive) this.sectionActive.classList.remove("active")
      if (this.tabActive) this.tabActive.classList.remove("active")

      if (e.type === "click" || link !== this.tabActive) {
        link.classList.add("active")
        if (section) section.classList.add("active")
        this.sectionActive = section
        this.tabActive = link
        return false
      }
      this.sectionActive = undefined
      this.tabActive = undefined
    }
    this.tabsNavigator.addEventListener("click", displayTab)
    this.tabsNavigator.addEventListener("dblclick", displayTab)

    this.parse()

    const setDesign = () => {
      if (this.desktop === this.mobile) return this.classList.add(this.desktop)
      if (window.innerWidth > BP) {
        console.log("Seteamos desktop")
        this.classList.add(this.desktop)
        this.classList.remove(this.mobile)
        console.log(this)
        return false
      }
      console.log("Seteamos mobile")
      this.classList.remove(this.desktop)
      this.classList.add(this.mobile)
    }
    setDesign()
    if (this.desktop != this.mobile) {
      window.addEventListener("resize", setDesign)
    }

    console.log("tabs")
  }
  parse() {
    if (this.onlyTabs) {
      const heading = document.createElement("h5")
      heading.textContent = this.tabTitle
      if (!this.childNodes[0].tagName || this.childNodes[0].tagName != "H5") this.insertAdjacentElement("afterbegin", heading)
    } else if (!this.querySelector("h5")) return

    let tabs = false
    this.tabs = []
    this.sections = [];

    [...this.childNodes].forEach((item, index) => {
      const isText = item.nodeType === this.TEXT_NODE
      if (isText) {
        const content = item.textContent.trim()
        if (content === "") {
          item.remove()
          return
        }
        const wrapper = document.createElement("p")
        item.replaceWith(wrapper)
        wrapper.appendChild(item)
        item = wrapper
      }

      if (item.tagName === 'BR') {
        item.remove()
        return
      }

      if (item.tagName === "H5") {
        if (!tabs) {
          tabs = true
          this.replaceChild(this.container, item)
        } else item.remove()

        this.tabs.push(item.textContent)
        this.sections.push([])
        return false
      } else if (!this.onlyTabs && item.tagName.startsWith("H") && tabs) return (tabs = false)
      if (tabs) this.sections[this.sections.length - 1].push(item)
    })

    this.tabs.forEach((tab, i) => {
      this.tabsNavigator.innerHTML += `<li><a href="#section-${i}">${tab}</a></li>`
      const container = document.createElement("div")
      container.id = `section-${i}`
      container.classList.add("tabs-navigator__section")

      const acordeonHandler = document.createElement("div")
      const compare = tab.trim().toLowerCase()
      acordeonHandler.innerHTML = `
      <span style="display: flex; gap: .5ch; align-items: center;">
        ${compare === 'especificaciones' ? ESPECIFICACIONES_SVG : ''}
        ${compare === '¿cómo medir tu pie?' ? FOOT_SIZE_SVG : ''}
        ${tab}
      </span>
      <svg aria-hidden="true" width="11" height="11" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
      </path></svg>`
      acordeonHandler.classList.add("acordeon-handler")

      acordeonHandler.addEventListener("click", (e) => {
        const a = this.tabsNavigator.querySelector(`[href="#section-${i}"]`)
        a.dispatchEvent(new Event("dblclick", { bubbles: true }))
      })

      container.append(acordeonHandler, ...this.sections[i])
      this.sectionsContainer.append(container)
    })
    if (this.tabs.length <= 1) return
    const first = this.tabsNavigator.querySelector("a")
    if (first && this.defaultActive) first.click()
  }
}

window.customElements.define("tabs-description", TabsNavigator)
